import React from 'react'
import "./Alertbar.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle, faExclamationTriangle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'

function Alertbar({ title, priority, style }) {

    let priorityIcon
    let priorityColor
    let textcolor

    switch(priority){
        case(2):
            priorityIcon = faExclamationTriangle
            priorityColor = "gold"
            textcolor = "black"
            break
        case(3):
            priorityIcon = faTimesCircle
            priorityColor = "red"
            textcolor = "white"
            break
        default:
            priorityIcon = faExclamationCircle
            priorityColor = "rgb(235, 235, 235)"
            textcolor = "black"
            break
    }

    return (
        <div style={style}>
            <div 
            className="alert-bar" 
            style={{
                backgroundColor: priorityColor,
                color: textcolor
            }}
            >
                <FontAwesomeIcon icon={priorityIcon} style={{ marginRight: 8 }}/>
                <div>{title}</div>
            </div>
        </div>
    )
}

export default Alertbar
